export default "__VITE_ASSET__B1yl7GFi__"